'use strict';

import googleMapTemplate from './gmap.directive.html';
import 'ngmap';

export default angular
  .module('maestro.directives.components.gmap', [
    'ngMap'
  ])

  .directive('gmap', () => {
    return {
      restrict: 'E',
      template: googleMapTemplate,
      scope: {
        id: '@',
        zoom: '=',
        latitude: '=',
        longitude: '=',
        distance: '='
      },
      controller: ($scope, GoogleMapsService, NgMap) => {
        const defaultMapCenter = { lat: 41.66891793099595, lng: -70.29606913862301 };

        angular.extend($scope, {
          id: $scope.id || 'google-map-' + Math.floor(Math.random() * 1000000),
          zoom: $scope.zoom || 15,
        });

        init();

        function init() {
          $scope.$watchGroup(['latitude', 'longitude', 'distance'], () => {
            updateMapCenter();
          });

          GoogleMapsService.getGoogleMapsUrl()
            .then(url => {
              $scope.googleMapsUrl = url;
            });
        }

        function updateMapCenter() {
          return NgMap.getMap({id: $scope.id})
            .then(map => {
              map.setCenter({
                lat: Number($scope.latitude ? $scope.latitude : defaultMapCenter.lat),
                lng: Number($scope.longitude ? $scope.longitude : defaultMapCenter.lng)
              });
            });
        }
      }
    };
  })
  .name;
